<template>
	<div class="tabs-menu">
		<el-tabs v-if="menu.length != 1" class="article_tab" :class="{fixed:isFixed}" v-model="tab_active" @tab-click="tabClick">
			<template v-for="(item,i) in menu">
				<el-tab-pane :name="item.name" :index="i" :label="item.name"></el-tab-pane>
			</template>
		</el-tabs>
		<div  v-if="menu.length != 1" style="padding-top: 60px;"></div>
		<div class="article_txt">
			<template v-for="item in menu">
				<h3 class="article_title"><i class="el-icon-caret-right"></i>{{item.name}}</h3>
				<template v-for="i in item.text">
					<div class="img_box" v-if="i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0 || i.indexOf('jpg') >= 0">
						<img :src="i" />
					</div>
					<div class="p_box" v-else>
						<p v-html="i"></p>
					</div>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tabs-menu',
		data() {
			return {
				isFixed: false,
				tab_active: this.menu[0].name,
				y: {
					scroll: 0,
					tabs: 0,
					title: []
				},
			}
		},
		//计算数据
		computed: {},
		//参数数据
		props: {
			"menu": {},
			"width": {}
		},
		//方法
		methods: {
			fnScroll() {
				this.y.scroll = window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop ||
					0;
			},
			tabClick(i, o) {
				window.scrollTo(0, this.y.title[i.index] + 140);
			}
		},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {
			this.y.tabs =  document.getElementsByClassName("article_tab")[0].offsetTop + 95;
			this.y.title = new Array();
			var title_list = document.getElementsByClassName("article_title");
			for(var i = 0; i < title_list.length; i++) {
				this.y.title.push(title_list[i].offsetTop - 80);
			}

			if(window.attachEvent) {
				window.attachEvent('onscroll', this.fnScroll);
			} else if(document.addEventListener) {
				document.addEventListener('scroll', this.fnScroll, false);
			}
		},
		//监控变量
		watch: {
			menu: function(newV) {
				this.tab_active = newV[0].name;
				this.$nextTick(function() {
					this.y.title = new Array();
					var title_list = document.getElementsByClassName("article_title");
					for(var i = 0; i < title_list.length; i++) {
						this.y.title.push(title_list[i].offsetTop - 80);
					}
				})
			},
			"y.scroll":function(newV){				
				this.isFixed = newV >= this.y.tabs;
				for(var i = 0; i < this.y.title.length; i++) {
					if(newV > this.y.title[i]) {
						this.tab_active = this.menu[i].name;
					}
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import url("../assets/common.less");
	.tabs-menu {
		.el-tabs {
			position: absolute;
			background-color: #FFFFFF;
			z-index: 999;
			width: 803px;
			&.fixed {
				position: fixed;
				top: 0;
			}
			.el-tabs__item {
				min-width: 100px;
				text-align: center;
			}
		}
		.article_txt {
			min-height: 100vh;
			.article_title {
				font-size: 20px;
				line-height: 2em;
				padding: 20px 20px 20px 30px;
				i {
					font-size: 0.7em;
					color: @theme-color;
					padding-right: 15px;
				}
			}
			p {
				text-indent: 2em;
				padding: 0 20px 20px;
			}
			.img_box {
				text-align: center;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// tabs-menu.vue?51b3a1e7